<template>
  <div class="text-center">
    <v-dialog scrollable v-model="dialog" ref="dlgInfo" width="850">
      <template v-slot:activator="{}"></template>

      <v-card>
        <v-card-title class="headline mb-6 primary white--text">{{ title }}</v-card-title>

        <v-card-text>
          <v-row class="pa-2">
            <v-col cols="12" sm="3" md="3" lg="3" xl="3" v-if="$vuetify.breakpoint.smAndUp">
              <v-img src="https://cdn.siap.id/s3/simpkb/asset%20img/guru-praktik-baik/modal.png"></v-img>
            </v-col>
            <v-col cols="12" sm="9" md="9" lg="9" xl="9">
              <span class="black--text text-xl-body-1"
                >Ayo ikuti webinar selasa seru webinar selasa seru pada tanggal <b>14 Mei pukul 13.30 s.d. 15.30</b> yang akan mengangkat topik:
                <b>Kelola Emosi dengan Tetap Hadapi Anak Usia Dini</b></span
              >
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <m-button class="my-2 mx-6" text color="info white--text" textButton="Tutup" action="toClose" @toClose="dialog = false"></m-button>
          <m-button class="my-2 mx-6" depressed color="info white--text" icon="mdi-link" textButton="Daftar" action="toRegistrasi" @toRegistrasi="toRegistrasi"></m-button>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
//@group Global Feature

export default {
  name: "home-form-join-telegram",
  data() {
    return {
      dialog: false,
      config: null,
      loading: false,
      itemSurvey: [],
      title: null,
      konten: null,
      isTautan: false
    };
  },

  methods: {
    //@vuese
    //buka dialog dan ambil data konfigurasi telegram
    // eslint-disable-next-line
    open() {
      return new Promise((resolve, reject) => {
        this.title = "Selamat pagi Sahabat Guru Paud dan dikmas.";
        this.resolve = resolve;
        this.reject = reject;
        this.dialog = true;
      });
    },

    toRegistrasi() {
      window.open("http://s.id/SELASASERU_MEI", "_blank");
    }
  }
};
</script>
